import "./chat.css";
import { EditDp, Navbar } from "../Components";
import CustomTop from "./CustomTop";
import "bootstrap/dist/css/bootstrap.min.css";
import { BiSearch } from "react-icons/bi";
import { MdOutlineArrowBackIos } from "react-icons/md";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { supabase } from "../Utils/supabaseClient";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { UpgradePage } from "./UpgradePage";
import { Modal } from "react-bootstrap";

import { CraftsModal } from "./CraftsModal";

import {
  setActiveChatUserId,
  updateConversation,
  recalculateTotalUnread,
  setConversations,
} from "../redux/Slices/chatSlice";
const MessagesPage = () => {
  const { hcc_id: otherHccId } = useParams();
  const reduxConversations = useSelector((state) => state.chat.conversations);
  let profile_data = JSON.parse(localStorage.getItem("profile_data"));

  const dispatch = useDispatch();

  const navigate = useNavigate();
  const myHccId = localStorage.getItem("hcc_id");

  const [showApply, setshowApply] = useState(false);
  const [profilePic, setProfilepic] = useState(false);
  const [UpgradeShow, setUpgradeShow] = useState(false);
  const [ScreenVisbile, setScreenVisbile] = useState("plans");

  const conversations = useSelector((state) => state.chat.conversations);
  useEffect(() => {
    console.log("[UI] Redux conversations updated:", conversations);
  }, [conversations]);

  const [userMap, setUserMap] = useState({});
  const [messages, setMessages] = useState([]);
  const [messageText, setMessageText] = useState("");
  const chatRef = useRef(null);
  const textareaRef = useRef(null); // ← for auto-resizing textarea

  useEffect(() => {
    // Fetch initial conversations when the component mounts
    const fetchConversations = async () => {
      const { data, error } = await supabase
        .from("conversations")
        .select("*")
        .or(`user1_id.eq.${myHccId},user2_id.eq.${myHccId}`);
      if (error) {
        console.error("Error fetching conversations:", error);
        return;
      }
      dispatch(setConversations(data)); // Update Redux store with conversations
    };
    fetchConversations();
  }, [myHccId, dispatch]);

  useEffect(() => {
    const updatePresence = async (active) => {
      const { data: convo } = await supabase
        .from("conversations")
        .select("*")
        .or(
          `and(user1_id.eq.${myHccId},user2_id.eq.${otherHccId}),and(user1_id.eq.${otherHccId},user2_id.eq.${myHccId})`
        )
        .maybeSingle();

      if (convo) {
        const updateField =
          convo.user1_id === myHccId
            ? { is_user1_active: active }
            : { is_user2_active: active };

        await supabase
          .from("conversations")
          .update(updateField)
          .eq("id", convo.id);
      }
    };

    if (otherHccId) {
      dispatch(setActiveChatUserId(otherHccId));
      updatePresence(true);
      return () => {
        dispatch(setActiveChatUserId(null));
        updatePresence(false);
      };
    }
  }, [otherHccId]);

  const fetchUserDetails = async (ids) => {
    const { data } = await supabase
      .from("users")
      .select(
        "hcc_id, first_name, last_name, profile_pic_url, is_online, last_active_at"
      )
      .in("hcc_id", ids);
    if (data) {
      const map = {};
      data.forEach((u) => (map[u.hcc_id] = u));
      setUserMap(map);
    }
  };

  const fetchMessages = async () => {
    const { data } = await supabase
      .from("messages")
      .select("*")
      .or(
        `and(sender_id.eq.${myHccId},receiver_id.eq.${otherHccId}),and(sender_id.eq.${otherHccId},receiver_id.eq.${myHccId})`
      )
      .order("created_at", { ascending: false });
  
    if (data) {
      const reversed = data.reverse();
      setMessages(reversed);
    }
  };
  
  useEffect(() => {
    if (messageText === "" && textareaRef.current) {
      textareaRef.current.style.height = "auto";
    }
  }, [messageText]);

  const handleSend = async () => {
    if (!messageText.trim()) return;

    const timestamp = new Date().toISOString();
    const tempId = `temp-${Date.now()}`;

    const optimisticMessage = {
      id: tempId,
      sender_id: myHccId,
      receiver_id: otherHccId,
      content: messageText,
      created_at: timestamp,
      isOptimistic: true,
    };

    setMessages((prev) => [...prev, optimisticMessage]);
    setMessageText("");

    const { data: convo } = await supabase
      .from("conversations")
      .select("*")
      .or(
        `and(user1_id.eq.${myHccId},user2_id.eq.${otherHccId}),and(user1_id.eq.${otherHccId},user2_id.eq.${myHccId})`
      )
      .maybeSingle();

    if (!convo) {
      await supabase.from("conversations").insert({
        user1_id: myHccId,
        user2_id: otherHccId,
        last_message: optimisticMessage.content,
        last_message_time: timestamp,
        user1_unread: 0,
        user2_unread: 0,
        is_user1_active: myHccId === convo?.user1_id,
        is_user2_active: myHccId === convo?.user2_id,
      });
    } else {
      const updateFields = {
        last_message: optimisticMessage.content,
        last_message_time: timestamp,
      };

      const recipientIsActive =
        (convo.user1_id === otherHccId && convo.is_user1_active) ||
        (convo.user2_id === otherHccId && convo.is_user2_active);

      if (!recipientIsActive) {
        if (convo.user1_id === otherHccId) {
          updateFields.user1_unread = (convo.user1_unread || 0) + 1;
        } else if (convo.user2_id === otherHccId) {
          updateFields.user2_unread = (convo.user2_unread || 0) + 1;
        }
      }

      await supabase
        .from("conversations")
        .update(updateFields)
        .eq("id", convo.id);
    }

    const { data, error } = await supabase
      .from("messages")
      .insert({
        sender_id: myHccId,
        receiver_id: otherHccId,
        content: optimisticMessage.content,
      })
      .select()
      .single();

    if (!error && data) {
      setMessages((prev) =>
        prev.map((msg) => (msg.id === tempId ? data : msg))
      );
    }
  };

  const subscribeToMessages = () => {
    const channel = supabase
      .channel("chat-realtime")
      .on(
        "postgres_changes",
        {
          event: "INSERT",
          schema: "public",
          table: "messages",
          filter: `receiver_id=eq.${myHccId}`,
        },
        (payload) => {
          const message = payload.new;
          if (message.sender_id === otherHccId) {
            setMessages((prev) => [...prev, message]);
          }
        }
      )
      .subscribe();

    return () => supabase.removeChannel(channel);
  };

  // useEffect(() => {
  //   fetchConversations();
  // }, []);

  useEffect(() => {
    const ids = conversations.map((c) =>
      c.user1_id === myHccId ? c.user2_id : c.user1_id
    );
    if (otherHccId) ids.push(otherHccId);
    fetchUserDetails([...new Set(ids)]);
  }, [conversations, otherHccId]);

  useEffect(() => {
    const resetUnreadCount = async () => {
      await supabase.rpc("reset_unread_count", {
        user_a: myHccId,
        user_b: otherHccId,
      });
      const existing = reduxConversations.find(
        (c) =>
          (c.user1_id === myHccId && c.user2_id === otherHccId) ||
          (c.user1_id === otherHccId && c.user2_id === myHccId)
      );
      if (existing) {
        const patched = {
          ...existing,
          user1_unread:
            existing.user1_id === myHccId ? 0 : existing.user1_unread,
          user2_unread:
            existing.user2_id === myHccId ? 0 : existing.user2_unread,
        };

        dispatch(updateConversation(patched));
        dispatch(recalculateTotalUnread());
      }
    };
    if (otherHccId) {
      resetUnreadCount();

      fetchMessages();
      const unsub = subscribeToMessages();
      return unsub;
    }
  }, [otherHccId]);

  useEffect(() => {
    if (chatRef.current) {
      chatRef.current.scrollTop = chatRef.current.scrollHeight;
    }
  }, [messages]);

  const selectedUser = userMap[otherHccId];

  const formatLastSeen = (timestamp) => {
    if (!timestamp) return "";
    const last = new Date(timestamp);
    const now = new Date();
    const diff = Math.floor((now - last) / 1000);
    if (diff < 60) return "Just now";
    if (diff < 3600) return `${Math.floor(diff / 60)} min ago`;
    if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
    return last.toLocaleString();
  };

  const handleTextareaInput = () => {
    const textarea = textareaRef.current;
    if (!textarea) return;

    textarea.style.height = "auto";
    textarea.style.height = Math.min(textarea.scrollHeight, 120) + "px"; // ~5 lines
  };

  const handleUpgradeClose = () => {
    setUpgradeShow(false);
    setScreenVisbile("plans");
  };
  const handleprofilpicclose = () => {
    setProfilepic(false);
  };
  const handleClose = () => {
    setshowApply(false);
  };
  const HandleProfilepic = () => {
    if (profile_data?.profile_pic === null) {
      setProfilepic(true);
    } else if (localStorage.getItem("is_24_craft") === null) {
      setshowApply(true);
    } else {
      setUpgradeShow(true);
    }
  };
  const UpgradeCheck = () => {
    // if (localStorage.getItem("token")) {
    //   if (localStorage.getItem("is_pro") === "true") {
    //     handleSend();
    //   } else {
    //     HandleProfilepic();
    //   }
    // } else {
    //   document.querySelector(".login-text").click();
    // }
            handleSend();

  };

  const convertLinks = (text) => {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    return text.replace(urlRegex, (url) => {
      const safeUrl = url.replace(/"/g, "&quot;"); // basic XSS protection
      return `<a href="${safeUrl}" target="_blank" rel="noopener noreferrer">${url}</a>`;
    });
  };

  return (
    <>
      <CustomTop />
      <div className="search-screen-container search-page">
        <Navbar />
        <div className="content-area chat-container">
          <div className={otherHccId ? "hidden chat-list" : "chat-list"}>
            <h4>
              <MdOutlineArrowBackIos size={20} onClick={() => navigate(-1)} />
              All Chats
            </h4>
            <div className="searchbar">
              <input type="search" placeholder="Search for people" />
              <BiSearch size={25} color="#9D9D9D" />
            </div>
            <div className="chat-items">
              {[...conversations]
                .sort(
                  (a, b) =>
                    new Date(b.last_message_time).getTime() -
                    new Date(a.last_message_time).getTime()
                )
                .map((convo) => {
                  const otherId =
                    convo.user1_id === myHccId
                      ? convo.user2_id
                      : convo.user1_id;
                  const user = userMap[otherId];
                  const globalConvo = reduxConversations.find(
                    (c) => c.id === convo.id
                  );
                  const unreadCount =
                    globalConvo?.user1_id === myHccId
                      ? globalConvo?.user1_unread
                      : globalConvo?.user2_unread;

                  // Format the last message time in 12-hour format with AM/PM
                  const lastMessageTime = new Date(convo.last_message_time);
                  const formattedTime = lastMessageTime.toLocaleString(
                    "en-US",
                    {
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: true, // Ensures 12-hour format
                    }
                  );

                  return (
                    <div
                      key={convo.id}
                      onClick={() => navigate(`/messages/${otherId}`)}
                      style={{
                        padding: "10px",
                        background: otherHccId === otherId ? "#f0e6ff" : "#fff",
                        cursor: "pointer",
                        borderBottom: "1px solid #eee",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <img
                        src={
                          user?.profile_pic_url ||
                          require("../Components/Post/images/male.jpg")
                        }
                        alt="user"
                        style={{
                          width: 40,
                          height: 40,
                          borderRadius: "50%",
                          marginRight: 10,
                          objectFit: "cover",
                        }}
                      />
                      <div>
                        <strong>{user?.first_name}</strong>
                        <div className="last-message-time">
                          <p
                            style={{
                              margin: 0,
                              fontSize: "0.85em",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              maxWidth: "180px", // adjust as per layout
                            }}
                          >
                            {" "}
                            {convo.last_message}
                          </p>
                          <div style={{ fontSize: "0.75em", color: "#777" }}>
                            {formattedTime} {/* The formatted time */}
                          </div>
                        </div>
                      </div>

                      {unreadCount > 0 && otherHccId !== otherId && (
                        <div
                          style={{
                            backgroundColor: "#ff3b30",
                            color: "#fff",
                            fontSize: "12px",
                            padding: "3px 8px",
                            borderRadius: "50%",
                            minWidth: "20px",
                            textAlign: "center",
                            marginLeft: "10px",
                          }}
                        >
                          {unreadCount}
                        </div>
                      )}
                    </div>
                  );
                })}
            </div>
          </div>

          <div
            className={
              otherHccId ? "chat-window" : "message-dummy-content hidden"
            }
          >
            {!otherHccId ? (
              <div className="no-chat-selected">
                <img src={require("./images/dummy-message-symbol.png")} />
                <h2>Your Messages</h2>
                <p>Send a message to start a chat.</p>
              </div>
            ) : (
              <>
                <div
                  className="chat-header"
                  style={{ cursor: "pointer" }}
                  onClick={() => navigate(`/profile/${selectedUser?.hcc_id}`)}
                >
                  {" "}
                  <MdOutlineArrowBackIos
                    size={20}
                    onClick={() => navigate(-1)}
                  />
                  <img
                    src={
                      selectedUser?.profile_pic_url ||
                      require("../Components/Post/images/male.jpg")
                    }
                    alt="user"
                    className="chat-profile-pic"
                  />
                  <div className="user-info" style={{ margin: 0 }}>
                    <div className="header-name" style={{ margin: 0 }}>
                      {selectedUser?.first_name}
                    </div>
                    <p style={{ margin: 0 }}>{selectedUser?.hcc_id}</p>
                    {(selectedUser?.is_online ||
                      selectedUser?.last_active_at) && (
                      <p className="status" style={{ margin: 0 }}>
                        {selectedUser?.is_online
                          ? "Online"
                          : `Last seen: ${formatLastSeen(
                              selectedUser.last_active_at
                            )}`}
                      </p>
                    )}
                  </div>
                </div>
                <div className="chat-body" ref={chatRef}>
                  {(() => {
                    let lastRenderedDate = null;

                    return messages.map((msg) => {
                      const sender = userMap[msg.sender_id];
                      const isMine = msg.sender_id === myHccId;

                      const msgDate = new Date(msg.created_at);
                      const msgDateStr = msgDate.toDateString();

                      let showDateDivider = false;
                      if (msgDateStr !== lastRenderedDate) {
                        lastRenderedDate = msgDateStr;
                        showDateDivider = true;
                      }

                      const time = msgDate.toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: true, // 👈 this ensures AM/PM
                      });

                      const getDateLabel = (date) => {
                        const today = new Date();
                        const yesterday = new Date();
                        yesterday.setDate(today.getDate() - 1);

                        if (date.toDateString() === today.toDateString())
                          return "Today";
                        if (date.toDateString() === yesterday.toDateString())
                          return "Yesterday";

                        return date.toLocaleDateString(undefined, {
                          day: "numeric",
                          month: "long",
                          year: "numeric",
                        });
                      };

                      return (
                        <React.Fragment key={msg.id}>
                          {showDateDivider && (
                            <div className="date-divider">
                              {getDateLabel(msgDate)}
                            </div>
                          )}

                          <div
                            className={`chat-message ${
                              isMine ? "sent" : "received"
                            }`}
                          >
                            {!isMine && (
                              <img
                                src={
                                  sender?.profile_pic_url ||
                                  require("../Components/Post/images/male.jpg")
                                }
                                className="profile-pic-small"
                                alt="sender"
                              />
                            )}
                            <div className="message-bubble">
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: convertLinks(msg.content),
                                }}
                              />
                              <div className="msg-time">{time}</div>
                            </div>
                          </div>
                        </React.Fragment>
                      );
                    });
                  })()}
                </div>

                <div className="message-input">
                  <textarea
                    rows={1}
                    ref={textareaRef}
                    placeholder="Type here..."
                    value={messageText}
                    onChange={(e) => {
                      setMessageText(e.target.value);
                      handleTextareaInput();
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" && !e.shiftKey) {
                        e.preventDefault();
                        UpgradeCheck();
                      }
                    }}
                  />
                  <button
                    className="bg-[#e6d4fb] hover:bg-[#d3baf7] text-gray-600 font-medium 
             px-3 py-1.5 text-sm sm:px-5 sm:py-2 sm:text-base 
             rounded-xl border border-gray-300 shadow-sm 
             transition duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
                    onClick={UpgradeCheck}
                  >
                    Send
                  </button>
                </div>
              </>
            )}
          </div>
        </div>

        {/* <Footer /> */}
        {UpgradeShow && (
          <UpgradePage
            UpgradeShow={UpgradeShow}
            setUpgradeShow={setUpgradeShow}
            ScreenVisbile={ScreenVisbile}
            setScreenVisbile={setScreenVisbile}
            handleUpgradeClose={handleUpgradeClose}
          />
        )}
        <Modal
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={profilePic}
          onHide={handleprofilpicclose}
          className="edit-profile-popup"
        >
          <Modal.Header closeButton>
            <Modal.Title>Add your profile to get started</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <EditDp
              handleLoginEvent={handleprofilpicclose}
              showApply={showApply}
              setshowApply={setshowApply}
            />
          </Modal.Body>
        </Modal>
        {showApply && (
          <CraftsModal
            showApply={showApply}
            setshowApply={setshowApply}
            handleClose={handleClose}
          />
        )}
      </div>
    </>
  );
};

export { MessagesPage };
